import {createContext, useContext, useEffect, useState} from "react";
import {useMainContext} from "./main";
import {loadPersistedData, persistData} from "../utils/persistor";
import {desktopDefaultLayout, enDesktopDefaultLayout, fullscreenLayout, fullscreenLayoutL} from "../constants/layouts";
import {useWindowSize} from "../hooks/common/useWindowSize";


const context = createContext({})

export const useLayoutContext = () => {
    return useContext(context)
}

const initialLayoutCache = {
    classic: '',
    fullscreen: ''
}

const LayoutContextProvider = (props) => {

    const { main: { lang } } = useMainContext()
    const [availableLayouts, setAvailableLayouts] = useState()
    const [activeLayout, setActiveLayout] = useState(loadPersistedData('active-layout') || 'classic')
    const [layout, setLayout] = useState()

    const { width } = useWindowSize()

    const setFullscreenLayout = () => {
        if (activeLayout === 'fullscreen') {
            if (width > 1500) setLayout(fullscreenLayout(lang))
            else setLayout(fullscreenLayoutL(lang))
        }
    }

    useEffect(() => {
        setFullscreenLayout()
    }, [width])

    useEffect(() => {
        persistData('active-layout', activeLayout)
        const cache = loadPersistedData('layout')
        if (!cache) {
            persistData('layout', initialLayoutCache)
        }
        if (activeLayout === 'classic') {
            if (lang === 'en') setLayout(enDesktopDefaultLayout)
            else setLayout(desktopDefaultLayout)
            return
        }
        if (activeLayout === 'fullscreen') {
            setFullscreenLayout()
            return
        }
        setLayout(cache[activeLayout])
    }, [activeLayout, lang])

    const refreshAvailableLayouts = () => {
        const cache = loadPersistedData('layout')
        setAvailableLayouts(Object.keys(cache))
    }

    const deleteLayout = (layout) => {
        if (layout === activeLayout) setActiveLayout('classic')
        const layouts = loadPersistedData('layout')
        const fullscreen = loadPersistedData('fullscreen')
        try {
            delete layouts[layout]
            persistData('layout', layouts)
            if (fullscreen.includes(layout)) {
                const newFullscreen = fullscreen.filter(x => x !== layout)
                persistData('fullscreen', newFullscreen)
            }
            refreshAvailableLayouts()
        }
        catch (err) { console.log(err) }
    }

    useEffect(() => {
        refreshAvailableLayouts()
    }, [])

    /**
     * fullscreen
     */
    useEffect(() => {
        const fullscreen = loadPersistedData('fullscreen')
        if (!fullscreen) persistData('fullscreen', ['fullscreen'])
    }, [])

    return (
        <context.Provider
            value={{
                layout, setLayout,
                activeLayout, setActiveLayout,
                availableLayouts, refreshAvailableLayouts,
                deleteLayout
            }}
        >
            {props.children}
        </context.Provider>
    )
}

export default LayoutContextProvider
